<template>
    <div>
        <p class="overline">{{ $t('bulk_orders_import.status.status') }}</p>
        <div v-if="data">
            <v-chip small :color="statusColor(data.status)" class="mb-3">
                {{ $t("bulk_orders_import.status." + data.status) }}
            </v-chip>
            <p v-if="data.error">
                <v-icon color="error">mdi-alert-outline</v-icon>
                <span class="error--text">{{ data.error }}</span>
            </p>
        </div>
        <p class="overline">{{ $t('bulk_orders_import.statistics') }}</p>
        <div v-if="data && data.statistics !== null">
            <div v-for="(column, i) in statistics" :key="column.id">
                <p class="my-1">{{ $t("bulk_orders_import.domain_columns." + column.code) }}</p>
                <p class="mb-0 caption">
                    <span :class="{'font-weight-bold': column.created > 0}">
                        {{ $t('bulk_orders_import.created') }}: {{ column.created }}
                    </span>,
                    <span :class="{'font-weight-bold': column.updated > 0}">
                        {{ $t('bulk_orders_import.updated') }}: {{ column.updated }}
                    </span>
                </p>
                <hr v-if="i < statistics.length - 1"/>
            </div>
        </div>
        <div v-else>
            <p class="my-1">{{ $t('bulk_orders_import.no_statistics') }}</p>
        </div>
    </div>
</template>

<script>
import {API} from "@/api/api";

export default {
    name: "CreateBulkOrderImportStatistics",
    props: {
        importId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        // loading
        isBusyImport: false,
        // data (can not use "import" variable name)
        data: null
    }),
    computed: {
        isBusy() {
            return this.isBusyImport;
        },
        statistics() {
            let columns = this.data.statistics ? JSON.parse(this.data.statistics).columns : [];
            return columns.sort((a, b) => a.code > b.code ? 1 : (b.code > a.code ? -1 : 0))
                .map(column => {
                    if (column.code === "bulk_external_order") {
                        column.code = "bulk_external_order.root"; // just for translation purpose
                    }
                    if (column.code === "bulk_external_order.buyer") {
                        column.code = "bulk_external_order.buyer.root"; // just for translation purpose
                    }
                    if (column.code === "bulk_external_order.buyer.delivery_address") {
                        column.code = "bulk_external_order.buyer.delivery_address.root"; // just for translation purpose
                    }
                    return column;
                });
        }
    },
    methods: {
        onFetchImport() {
            this.isBusyImport = true;
            API.get("/api/bulk-order-imports/" + this.importId)
                .then(response => {
                    this.data = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyImport = false;
                })
        },
        statusColor(status) {
            switch (status) {
                case 'uploaded':
                case 'queued':
                case 'dry-run-finished':
                case 'dry-run-queued':
                    return "primary";
                case 'processing':
                case 'dry-run-processing':
                    return "warning"
                case 'failed':
                case 'validation-failed':
                case 'dry-run-failed':
                case 'dry-run-validation-failed':
                    return "error";
                case 'finished':
                    return "success"
            }
        }
    },
    created() {
        this.onFetchImport();
    }
}
</script>
